export const en = {
    action: 'Actions'
};
